import HomePageLayout from 'global/HomePageLayout';
import SEO from 'global/SEO';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';
import { AboutContainer, Container, Title } from './styled';
import AboutUs from './about';
import Vision from './vision';
import Management from './management';
import Contact from './contact';
import LicenseHolder from './LicenseHolder';

const GuestAbout = () => (
  <HomePageLayout hideStartInvesting>
    <SEO title="About Us | Stockbit - Komunitas Saham Indonesia" />

    <Container>
      <AboutUs />
      <Vision />
      <Management />
      <AboutContainer>
        {/* @ts-expect-error */}
        <Title align="center" mb="60px">Susunan organisasi</Title>
        <Flex align="center" justify="center" margin="0 0 160px 0">
          <Image src="/images/organizationNew2.svg" />
        </Flex>
      </AboutContainer>
      <LicenseHolder />
      <Contact />
    </Container>
  </HomePageLayout>
);

export default GuestAbout;
